import { Component, Input } from '@angular/core';
import { ProductChangeNoticeSection } from 'src/app/model/section/product-change-notice-section';

@Component({
  selector: 'app-product-change-notice-section',
  templateUrl: './product-change-notice-section.component.html',
  styleUrls: ['./product-change-notice-section.component.scss']
})
export class ProductChangeNoticeSectionComponent {
  @Input() productChangeNoticeSections: ProductChangeNoticeSection[] = [];
  constructor() {}
}
